/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  const REORDER_NOTICE_KEY = 'honey_reorder_notice';
  const REORDER_BUTTON_SELECTOR = '[data-reorder-button]';
  const REORDER_NOTE_SELECTOR = '[data-reorder-note]';
  const CART_NOTICE_SELECTOR = '[data-cart-reorder-notice]';

  const noticeHTML = (message) => `
    <div class="cart__errors__inner">
      <p class="cart__errors__content reorder-warning reorder-warning--inline">
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-out-of-stock" viewBox="0 0 22 22"><path d="M8.172 13.828 11.001 11m0 0 2.828-2.828M11.001 11 8.172 8.172M11.001 11l2.828 2.828M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>${message}</span>
      </p>
      <button class="cart__errors__close" type="button" data-reorder-notice-close aria-label="Close cart notice">
        <svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      </button>
    </div>
  `;

  const setReorderNotice = (message) => {
    try {
      sessionStorage.setItem(REORDER_NOTICE_KEY, message);
    } catch (error) {}
  };

  const clearReorderNotice = () => {
    try {
      sessionStorage.removeItem(REORDER_NOTICE_KEY);
    } catch (error) {}
  };

  const renderReorderNotice = () => {
    if (!document.body.classList.contains('template-cart')) return;

    let message = null;
    try {
      message = sessionStorage.getItem(REORDER_NOTICE_KEY);
    } catch (error) {}
    if (!message) return;

    const holder = document.querySelector(CART_NOTICE_SELECTOR);
    if (!holder) return;

    holder.innerHTML = noticeHTML(message);
    holder.classList.add('is-expanded');
    clearReorderNotice();

    const closeButton = holder.querySelector('[data-reorder-notice-close]');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        holder.classList.remove('is-expanded');
        holder.innerHTML = '';
      });
    }
  };

  const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const addToCart = (items) =>
    fetch(`${routesRoot}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    }).then((response) => response.ok);

  // Try the whole order in one request; if Shopify rejects it (e.g. one item hit
  // a quantity limit), add items one at a time so one bad item doesn't block the rest.
  const addReorderItems = async (items) => {
    try {
      if (await addToCart(items)) return { added: items.length, failed: 0 };
    } catch (error) {}

    let added = 0;
    for (const item of items) {
      try {
        if (await addToCart([item])) added += 1;
      } catch (error) {}
    }
    return { added, failed: items.length - added };
  };

  const showReorderError = (button, message) => {
    const scope = button.closest('[data-reorder-scope]') || document;
    const note = scope.querySelector(REORDER_NOTE_SELECTOR);
    const text = note && note.querySelector('[data-reorder-note-text]');
    if (!text) return;
    text.textContent = message;
    note.style.display = '';
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(REORDER_BUTTON_SELECTOR);
    if (!button) return;

    let items = [];
    try {
      items = JSON.parse(button.dataset.reorderItems || '[]');
    } catch (error) {
      return; // fall back to the link's href
    }
    if (!items.length) return;

    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');

    const skipped = parseInt(button.dataset.reorderSkipped, 10) || 0;
    const { added, failed } = await addReorderItems(items);

    if (added === 0) {
      button.removeAttribute('aria-disabled');
      showReorderError(button, button.dataset.reorderErrorMessage);
      return;
    }

    if (skipped > 0 || failed > 0) {
      setReorderNotice(button.dataset.reorderPartialMessage);
    }
    window.location.href = `${routesRoot}cart`;
  });

  renderReorderNotice();

  // The theme only binds the discount "x" when the discount code block is
  // enabled, so handle removal here when that block is turned off
  const handleizeCode = (code) => String(code).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  document.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('[data-remove-discount]');
    if (!removeButton || document.querySelector('[data-apply-discount]')) return;

    const discountBody = removeButton.closest('[data-discount-body]');
    if (!discountBody || discountBody.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    discountBody.setAttribute('aria-busy', 'true');

    try {
      const cart = await fetch(`${routesRoot}cart.js`).then((response) => response.json());
      const remainingCodes = (cart.discount_codes || [])
        .map((discount) => discount.code)
        .filter((code) => handleizeCode(code) !== discountBody.dataset.discountCode);

      await fetch(`${routesRoot}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: remainingCodes.join(',') }),
      });

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    } catch (error) {
      discountBody.removeAttribute('aria-busy');
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
